/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */

import React from 'react';
import { Text, StyleSheet } from 'react-native';
import { useSelector } from 'react-redux';

import Colors from '@global/colors';
import { getCurrency, isVn } from '@global/helpers';
import { isWeb } from '../../global/screens';
import { translate } from '@global/translate';
import { useTranslationDisabled } from '@components/shared/TranslationContext';

function SociollaText({
  children,
  style,
  type,
  currency,
  noWrap = false,
  ...otherProps
}) {
  // Subscribes this component to the language slice so it re-renders (and
  // re-runs translate() below) the instant the language changes, instead of
  // only picking up the new text on whatever next render its parent happens
  // to trigger for unrelated reasons.
  useSelector((state) => state.language.selected);
  const translationDisabled = useTranslationDisabled();

  let textStyle = {};
  let newChild = children;

  const currencyFormat = (num) => {
    const currency = getCurrency();
    let value = '';
    if (!num || num === 0 || num === '0') {
      value = 0;
    } else if (num == 'deleted') {
      return num;
    } else {
      value = Number(num)
        .toFixed(0)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    }
    if (isVn()) {
      return `${value} ${currency}`;
    }
    return `${currency} ${value}`;
  };

  switch (type) {
    case 'medium':
      textStyle = styles.medium;
      break;
    case 'bold':
      textStyle = styles.bold;
      break;
    default:
      textStyle = styles.default;
      break;
  }

  if (currency) {
    newChild = currencyFormat(children);
  } else if (!translationDisabled) {
    if (typeof children === 'string') {
      newChild = translate(children);
    } else if (Array.isArray(children)) {
      newChild = children.map((child) =>
        typeof child === 'string' ? translate(child) : child,
      );
    }
  }

  return (
    <Text
      style={[
        textStyle,
        style,
        !isWeb
          ? {
              flexWrap: noWrap ? 'nowrap' : 'wrap',
              flexShrink: 1,
            }
          : { whiteSpace: 'normal' },
        { lineHeight: style?.fontSize ? style.fontSize * 1.3 : 25 },
        otherProps.color && { color: otherProps.color },
      ]}
      {...otherProps}>
      {newChild}
    </Text>
  );
}

const styles = StyleSheet.create({
  default: {
    fontFamily: 'figtree-regular',
    color: Colors.black1,
    fontSize: 13,
  },
  medium: {
    fontFamily: 'figtree-semiBold',
  },
  // eslint-disable-next-line react-native/no-unused-styles
  medium1: {
    fontFamily: 'figtree-semiBold',
  },
  bold: {
    fontFamily: 'figtree-extraBold',
  },
});

export default SociollaText;
